import React, { useEffect, useState } from 'react';
import DefaultWidthContainer from '../../Layout/Containers/DefaultWidthContainer';
import TagComponent, { Tag } from './TagComponent';
import styles from './tagList.module.scss';
import { ResourceTypes } from '../../Models/ResourceProps';

type TagListProps = {
    tags: Array<Tag>;
    onSelect?: Function;
    defaults: Array<number>;
};

const TagListComponent = ({ tags, onSelect, defaults }: TagListProps) => {
    const [activeTags, setActiveTags] = useState<Array<number>>(defaults);

    const handleTagClick = (id: number) => {
        const existedActiveTagId = activeTags.find((t) => t === id);
        existedActiveTagId ? removeActiveTag(id) : addActiveTag(id);
    };

    useEffect(() => {
        if (typeof onSelect === 'function') {
            onSelect(activeTags);
        }
    }, [activeTags]);

    const removeActiveTag = (id: number) => {
        setActiveTags(activeTags.filter((t) => t !== id));
    };

    const addActiveTag = (id: number) => {
        setActiveTags([...activeTags, id]);
    };

    const tagAll: Tag = {
        id: 0,
        tagKey: ResourceTypes.ALL,
        name: ResourceTypes.ALL,
        count: tags.reduce((acc, tag) => {
            return acc + tag.count;
        }, 0),
        showCount: true,
    };

    const handleTagAllClick = () => {
        setActiveTags([]);
    };

    const isActiveTag = (id: number) => activeTags.includes(id);

    return (
        <DefaultWidthContainer extraClassNames={styles.tagsContainer}>
            <div className={styles.tags}>
                <TagComponent
                    key={`${tagAll.tagKey}-${tagAll.id}`}
                    id={tagAll.id}
                    isActive={activeTags.length === 0}
                    tagKey={tagAll.tagKey}
                    name={tagAll.name}
                    count={tagAll.count}
                    onTagClick={handleTagAllClick}
                    showCount={tagAll.showCount}
                />
                {tags.map((tag, index) => {
                    return (
                        <TagComponent
                            key={`${tag.tagKey}-${tag.id}`}
                            id={tag.id}
                            isActive={isActiveTag(tag.id)}
                            tagKey={tag.tagKey}
                            name={tag.name}
                            count={tag.count}
                            onTagClick={handleTagClick}
                            showCount={tag.showCount}
                        />
                    );
                })}
            </div>
        </DefaultWidthContainer>
    );
};

export default TagListComponent;
